import { ref } from 'vue';

const email = ref(null);
export const useEmail = () => {
	const getEmail = () => email;
	return { getEmail };
};
